import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../loader";
import { getPetNamesSuggestion,} from "../../actions/medicalRecords";
import _ from "lodash";


const $ = window.$;
class OpenAiPetNameSuggestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      PetId: "",
      petNamePrompt : {},
      openAiSuggestedPetsNames : [],
  
    };
  }

  onChangePetName = (event) => {
    if(event && event.target && event.target.value){
    this.setState({ petName : event.target.value});
    }
  }

  selectPetName = () => {
    let petName = this.state.petName;
    this.setState({ pet_name : petName });
    this.props.parentPetNameCallback(petName);
    $("#breed_name_suggestion-modal").modal("hide");
  }

  retryNameGenerate = () => {
    this.setState({ loadingPetNames : true, openAiSuggestedPetsNames : [] }, () => {
      this.props.getPetNamesSuggestion(this.state.petNamePrompt);
    });
  }

  componentDidMount() {  

  }
  
  componentWillReceiveProps = nextProps => {
    if(this.props.petNamePrompt !== nextProps.petNamePrompt){
      let promptData =  nextProps.petNamePrompt;
      if(promptData && !promptData.isDefault){
        $("#breed_name_suggestion-modal").modal("show");
      }
     this.setState({ loadingPetNames : true, petNamePrompt : nextProps.petNamePrompt }); 
     this.props.getPetNamesSuggestion(nextProps.petNamePrompt);
    }

    if(nextProps.suggestedPetsNames &&  nextProps.suggestedPetsNames.length > 0 && this.props.suggestedPetsNames !== nextProps.suggestedPetsNames){      
        this.setState({ openAiSuggestedPetsNames : nextProps.suggestedPetsNames, loadingPetNames : false, });          
    }  
  
    if( this.props.suggestedPetsNamesError !== nextProps.suggestedPetsNamesError){ 
      this.setState({ loadingPetNames : false, openAiSuggestedPetsNames : [] });    
      if(nextProps.suggestedPetsNamesError && nextProps.suggestedPetsNamesError.message &&  !_.isEmpty(nextProps.suggestedPetsNamesError.message)){  
          NotificationManager.error(nextProps.suggestedPetsNamesError.message);           
      }else{
        NotificationManager.error("An error occurred while loading the pet names"); 
      }
      $("#breed_name_suggestion-modal").modal("hide");
    }
  

 
  };

  render() {
    const { name,openAiSuggestedPetsNames,loadingPetNames } = this.state;
    return (
      <div
      className="modal fade"
      id="breed_name_suggestion-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ConfirmationModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Select Name For Puppy
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">

          <div className="row justify-content-center">
            <div className="col-10">
             { !loadingPetNames ?          
                <div className="m-widget4">	
                 <div className="row">
                  { openAiSuggestedPetsNames && openAiSuggestedPetsNames.length > 0 && openAiSuggestedPetsNames.map((name,index) =>(
                    <div className="col-6">
                      <div className="m-widget4__item" key={index}>
                        <div className="m-widget4__ext">
                          <span className="m-widget4__icon m--font-brand">                             
                          <input
                            type="radio"
                            name="petName"
                            value={name}                           
                            onChange={this.onChangePetName}
                          />
                          </span>
                        </div>									
                        <div className="m-widget4__info">
                          <span className="m-widget4__text">
                            {name}
                          </span>
                      </div>			
                      </div>	
                    </div>
                  ))
                 }
                 </div>								
                <div className="row mt-4">      
                  <a className="btn btn-warning m-btn btn-sm m-btn--icon m-btn--pill ml-4"
                      onClick={()=> this.retryNameGenerate()}   
                    >
                      <span>
                        <i className="fa fa-redo-alt"></i>
                        <span>Retry</span>
                      </span>
                    </a>
                </div>
              </div>
              :
              <div className="row justify-content-center">
                <div className="col-2">
                      <Loader size={25} />
                </div>
              </div>
             
             }  
             </div>         
          </div>
          </div>
          <div className="modal-footer">
            <div>
              <button
                type="button"
                className="btn btn-secondary m-btn--pill mx-2"
                data-dismiss="modal"
              >
                Cancel
                </button>
              <button
                type="button"
                onClick={() => this.selectPetName()}
                className="btn btn-primary m-btn--pill"
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  suggestedPetsNames : state.medicalRecordsReducer.suggestedPetsNames,
  suggestedPetsNamesError : state.medicalRecordsReducer.suggestedPetsNamesError,

});

const mapDispatchToProps = dispatch => ({
  getPetNamesSuggestion: (data) => {
    dispatch(getPetNamesSuggestion(data));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OpenAiPetNameSuggestion)
  );